import { Close2Icon, DocumentBadgePlusIcon, FormGridContainer, SearchIcon } from "@cpj-ai/panel-npm-package";
import { Button } from "@heroui/react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { getInputConfig, ICompanyFilterFormData } from "./formConfig";

interface SearchFormProps {
  handleFilter: (data: ICompanyFilterFormData) => void;
}

const SearchForm: React.FC<SearchFormProps> = ({ handleFilter }) => {
  const formHandler = useForm<ICompanyFilterFormData>();

  const [showExtraFilters, setShowExtraFilters] = useState(false);

  const handleSubmit = () => {
    const formValues = formHandler.getValues();
    const filteredValues = Object.entries(formValues).reduce((acc, [key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        acc[key as keyof ICompanyFilterFormData] = value;
      }
      return acc;
    }, {} as Partial<ICompanyFilterFormData>);

    handleFilter(filteredValues as ICompanyFilterFormData);
  };

  return (
    <div className="px-4 py-6 rounded-xl bg-white shadow-[0px_0px_10px_0px_rgba(0,_0,_0,_0.05)] border border-zinc-300">
      <div className="grid gap-4 items-end lg:grid-cols-10 relative">
        <div className={`${showExtraFilters ? "lg:col-span-10" : "lg:col-span-8"}`}>
          <FormGridContainer
            formHandler={formHandler as any}
            inputConfigs={getInputConfig({ showExtraFilters })}
            gridColumnSize={showExtraFilters ? 10 : 8}
          />
        </div>
        <div
          className={`flex justify-end items-center lg:col-span-2 ${showExtraFilters ? "absolute right-0 gap-2" : "gap-4"}`}
        >
          <Button
            variant="ghost"
            className={`rounded-xl  ${!showExtraFilters && "min-w-24"}`}
            onPress={() => setShowExtraFilters(!showExtraFilters)}
            isIconOnly={showExtraFilters}
            size="md"
          >
            {showExtraFilters ? (
              <Close2Icon stroke="#000" width={16} height={16} />
            ) : (
              <DocumentBadgePlusIcon stroke="#000" width={20} height={20} />
            )}
            {showExtraFilters ? "" : "Filter"}
          </Button>
          <Button
            onClick={formHandler.handleSubmit(handleSubmit)}
            startContent={<SearchIcon stroke="#fff" width={20} height={20} />}
            color="success"
            className={`rounded-xl order-1 text-sm  ${showExtraFilters && ""}`}
          >
            Search
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SearchForm;
